import Quill from 'quill'

const Parchment = Quill.import('parchment')

const UppercaseAttributor = new Parchment.Attributor.Class('case', 'case', {
    scope: Parchment.Scope.INLINE,
    whitelist: ['up', 'lw']
});

export { UppercaseAttributor }
